/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scene_Description_Job_FailedInputs */

const en_scene_description_job_failed = /** @type {(inputs: Scene_Description_Job_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to submit shot description job.`)
};

const fr_scene_description_job_failed = /** @type {(inputs: Scene_Description_Job_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échec de la soumission de la description de la prise de vue.`)
};

const de_scene_description_job_failed = /** @type {(inputs: Scene_Description_Job_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehler beim Einreichen der Shot-Beschreibung.`)
};

const it_scene_description_job_failed = /** @type {(inputs: Scene_Description_Job_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile inviare la descrizione dell'inquadratura.`)
};

const ru_scene_description_job_failed = /** @type {(inputs: Scene_Description_Job_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не удалось отправить описание задания.`)
};

const es_scene_description_job_failed = /** @type {(inputs: Scene_Description_Job_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo enviar la descripción del trabajo.`)
};

const zh_cn2_scene_description_job_failed = /** @type {(inputs: Scene_Description_Job_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提交镜头描述工作失败。`)
};

const ja_scene_description_job_failed = /** @type {(inputs: Scene_Description_Job_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`撮影内容の説明を送信できませんでした。`)
};

const hi_scene_description_job_failed = /** @type {(inputs: Scene_Description_Job_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शॉट विवरण जमा करने का कार्य विफल रहा।`)
};

const pt_pt2_scene_description_job_failed = /** @type {(inputs: Scene_Description_Job_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível enviar a descrição da cena.`)
};

/**
* | output |
* | --- |
* | "Failed to submit shot description job." |
*
* @param {Scene_Description_Job_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const scene_description_job_failed = /** @type {((inputs?: Scene_Description_Job_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scene_Description_Job_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_scene_description_job_failed(inputs)
	if (locale === "de") return de_scene_description_job_failed(inputs)
	if (locale === "it") return it_scene_description_job_failed(inputs)
	if (locale === "ru") return ru_scene_description_job_failed(inputs)
	if (locale === "es") return es_scene_description_job_failed(inputs)
	if (locale === "zh-CN") return zh_cn2_scene_description_job_failed(inputs)
	if (locale === "ja") return ja_scene_description_job_failed(inputs)
	if (locale === "hi") return hi_scene_description_job_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_scene_description_job_failed(inputs)
	return en_scene_description_job_failed(inputs)
});